import { Fragment, useState } from 'react';
import Box from '@mui/material/Box';
import { Button } from 'react-admin';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import ChangeStatusDialog from '@/components/common/change-status-dialog/change-status-dialog';
import { INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT } from '@/utils/CONST';

const DisordersTreatmentListBulkActionsButtons = () => {
    const [changeStatusDialogState, setChangeStatusDialogState] = useState<boolean>(false);

    const handleChangeStatusDialogOpen = () => {
        setChangeStatusDialogState(true);
    };

    const handleChangeStatusDialogClose = () => {
        setChangeStatusDialogState(false);
    };

    return (
        <Fragment>
            <Box
                sx={{
                    display: 'flex',
                    gap: 1,
                }}
            >
                <Button label={'buttons.change_status'} onClick={handleChangeStatusDialogOpen}>
                    <SyncAltIcon />
                </Button>
            </Box>

            {changeStatusDialogState && (
                <ChangeStatusDialog
                    open={changeStatusDialogState}
                    onClose={handleChangeStatusDialogClose}
                    choices={Object.values(INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT)}
                />
            )}
        </Fragment>
    );
};

export default DisordersTreatmentListBulkActionsButtons;
